import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export type ICreditsControlResponse = {
  credits_package: boolean
}

export type IPersonalRechargeItem = {
  tenant_user_id: string
  credits: number
  source: string
  source_id: string
  charge_mode: string
  begin_at: number
  end_at: number
  remark: string
  recharge_at: number
  used_credits?: number
}

export type IPersonalCreditsDetailResponse = {
  total_credits: number
  used_credits: number
  daily_used_credits: number
  frozen_credits: number
  items: IPersonalRechargeItem[]
}

export type ICompanyRechargeItem = {
  company_id: string
  credits: number
  source: string
  charge_mode: string
  begin_at: number
  end_at: number
  contract_no: string
  remark: string
  recharge_at: number
  created_by: string
  created_at: number
}

export type ICompanyCreditsDetailResponse = {
  total_credits: number
  used_credits: number
  daily_used_credits: number
  frozen_credits: number
  user_daily_limit: number
  company_user_daily_limit: number
  company_total_daily_limit: number
  items: ICompanyRechargeItem[]
}

export class CreditsApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async getCreditsControl(): Promise<IHttpWrap<ICreditsControlResponse>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('ai-service/credits/control'),
    })
  }

  async getPersonalCreditsDetail(): Promise<IHttpWrap<IPersonalCreditsDetailResponse>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('ai-service/credits/personal/detail'),
    })
  }

  async getCompanyCreditsDetail(): Promise<IHttpWrap<ICompanyCreditsDetailResponse>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('ai-service/credits/company/detail'),
    })
  }
}
